import {
    Alert, Button,
    CardHeader,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    MenuItem,
    Paper,
    Select,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {LoadingWrapper} from "../../components/LoadingWrapper";
import {Config} from "../../config/config";
import {getGlobalVar, Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

interface AddPurchase {
    visible: boolean;
    orderId: string;
    purchaseToken: string;
    productId: string;
    store: string;

}

interface PurchasesState {
    loaded: boolean;
    purchases: any[];
    modalVisible: boolean;
    selectAllProducts: boolean;
    checkedList: any[];
    savingData: boolean;
    addPurchaseModal: AddPurchase;
}

interface PurchasesProps {
    playerId: string;
    activeEnv: any;
    classes: any;
    playerData: any;
}

const sapphirePackages = [
    {packageId: "sapphires_pack_1", sapphires: 100, android: "sapphires_pack_1", ios: "sapphires_pack_1"},
    {packageId: "sapphires_pack_2", sapphires: 600, android: "sapphires_pack_2", ios: "sapphires_pack_2_v2"},
    {packageId: "sapphires_pack_3", sapphires: 1300, android: "sapphires_pack_3", ios: "sapphires_pack_3"},
    {packageId: "sapphires_pack_4", sapphires: 2800, android: "sapphires_pack_4", ios: "sapphires_pack_4"},
    {packageId: "sapphires_pack_5", sapphires: 7500, android: "sapphires_pack_5", ios: "sapphires_pack_5"},
    {packageId: "sapphires_pack_6", sapphires: 17000, android: "sapphires_pack_6", ios: "sapphires_pack_6"}
]

const stores = [
    {store: "android", name: "Google Play"},
    {store: "ios", name: "App Store"},
]


export class PlayerPurchases extends React.Component<PurchasesProps, PurchasesState> {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            purchases: [],
            modalVisible: false,
            selectAllProducts: false,
            checkedList: [],
            savingData: false,
            addPurchaseModal: {
                visible: false,
                orderId: "",
                purchaseToken: "",
                productId: sapphirePackages[0].packageId,
                store: stores[0].store,
            }
        };
    }

    componentDidMount() {
        this.fetchConfigData();
    }

    fetchUserPurchases = () => axios.get(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/purchases`, {
        headers: {Authorization: Helpers.getSessionId(), env: this.props.activeEnv},
    })

    getGoldPackData = (id, field) => {
        const goldPackData = getGlobalVar("PRODUCT_LIST").find(item => item.productId === id);

        if (!goldPackData) {
            if (field === "price") {
                return 0;
            }

            return "Unknown product";
        }

        if (field === "price") {
            return goldPackData ? goldPackData[field] : 0;
        }

        if (field === "name") {
            return goldPackData ? id : "Didn't pass validation";
        }

        return goldPackData ? goldPackData[field] : id;
    }

    showModal = () => {
        this.setState({
            modalVisible: true,
        });
    }

    closeModal = () => {
        this.setState({
            modalVisible: false,
        });
    }

    onSelectAllProducts = (e: any) => {
        this.setState({
            selectAllProducts: e.target.checked,
            checkedList: !e.target.checked ? [] : this.getProducts().map(item => item.productId),
        });
    }

    createDeals = async () => {
        this.setState({
            savingData: true,
        });
        try {
            await axios.post(
                `${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/create_deals`,
                {
                    products: this.state.checkedList,
                },
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                },
            );
            this.setState({
                modalVisible: false,
                checkedList: [],
                selectAllProducts: false,
            });
        } catch (e) {
            PopupMessage.error("Failed to create a deal: " + e.message);
        }
        this.setState({
            savingData: false,
        });
    }

    addPurchase = async () => {
        this.setState({
            savingData: true,
        });
        try {
            const {addPurchaseModal} = this.state;
            const {orderId, purchaseToken, productId, store} = addPurchaseModal;

            const product = sapphirePackages.find(item => item.packageId === productId);

            if (!product) {
                PopupMessage.error("Product not found");
                return;
            }

            // const producIdtByStore = product[store];

            const headers = {
                Authorization: Helpers.getSessionId(),
            }

            const body = {
                orderId,
                productId: product.packageId,
                purchaseToken,
                store
            }

            const url =  `${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/add_purchase`

            const response = await axios.post(url, body, {headers});

            const success = response.data.success;

            if (success) {
                this.onHideAddPurchaseModal();
                this.setState({
                    modalVisible: false,
                    checkedList: [],
                    selectAllProducts: false,
                });
                PopupMessage.success("Purchase added successfully");
            } else {
                PopupMessage.error("Failed to add purchase: " +  JSON.stringify(response.data.error));
            }

                        
        } catch (e) {
            PopupMessage.error("Failed to add purchase: " + e.message);
        }
        this.setState({
            savingData: false,
        });
    }

    totalPrice = () =>
        (this.state.purchases || []).reduce((total, item) =>
            total += this.getGoldPackData(item.product_id, "price"), 0)

    fetchConfigData = () =>
        axios.all([
            this.fetchUserPurchases(),
        ]).then(axios.spread(userPurchases => {
            this.setState({
                loaded: true,
                purchases: userPurchases.data.data,
            });
        })).catch((_err) => {
            PopupMessage.error("Couldn't load purchases");
        })

    onShowAddPurchaseModal = () => {
        const {addPurchaseModal} = this.state;

        this.setState({
            addPurchaseModal: {
                ...addPurchaseModal,
                visible: true,
            },
        });
    }

    onHideAddPurchaseModal = () => {
        const {addPurchaseModal} = this.state;

        this.setState({
            addPurchaseModal: {
                ...addPurchaseModal,
                visible: false,
            },
        });
    }

    drawButtons() {
        if (this.props.activeEnv === "prod") {
            return null;
        }

        if (this.props.playerData.is_online) {
            return null;
        }

        if (!this.state.loaded) {
            return <Skeleton
                width={110}
                height={45}
                style={{marginRight: 5}}
            />;
        }

        // return horizontal 2 cards
        return (
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <CardHeader
                    action={<Button disableElevation variant="contained" onClick={this.onShowAddPurchaseModal} size="small">Add Purchase</Button>}
                />
                <CardHeader
                    action={<Button disableElevation variant="contained" onClick={this.showModal} size="small">Create a deal</Button>}
                />
            </div>
        );
        // return <CardHeader
        //     action={<Button disableElevation variant="contained" onClick={this.showModal} size="small">Create a deal</Button>}
        // />;


    }

    onSelectProduct = (e: any) => {
        const tempList = [...this.state.checkedList];
        const itemIndex = tempList.findIndex(item => item === e.target.value);

        let selectAllProducts = this.state.selectAllProducts;

        if (itemIndex >= 0) {
            tempList.splice(itemIndex, 1);
            selectAllProducts = false;
        } else {
            tempList.push(e.target.value);
        }

        this.setState({
            checkedList: tempList,
            selectAllProducts,
        });
    }

    productItem(product) {
        return (
            <TableRow key={product.productId}>
                <TableCell>
                    {this.checkboxItem(product)}
                </TableCell>
                <TableCell>{product.productId}</TableCell>
                <TableCell>{product.price}</TableCell>
                <TableCell>{product.gold}</TableCell>
                <TableCell>{product.platform}</TableCell>
                <TableCell>{product.type}</TableCell>
                <TableCell>{product.slotIndex}</TableCell>
            </TableRow>
        );
    }

    checkboxItem = (product) => {
        const checked = this.state.checkedList.findIndex(item => item === product.productId) > -1 || this.state.selectAllProducts;
        return <Checkbox value={product.productId} onChange={this.onSelectProduct} checked={checked} />;
    }

    getProducts() {
        return getGlobalVar("PRODUCT_LIST");
    }

    onChangeAddPurchase = (event, field) => {
        this.setState({
            addPurchaseModal: {
                ...this.state.addPurchaseModal,
                [field]: event.target.value,
            },
        });
    }

    renderRows() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={4}>
                    {Helpers.renderSkeletonRows(3, 50)}
                </TableCell>
            </TableRow>
        }

        if (this.state.purchases.length === 0) {
            return <TableRow key="records_not_found">
                <TableCell colSpan={4}>
                    <Alert severity="info">No purchases found</Alert>
                </TableCell>
            </TableRow>
        }

        return <React.Fragment>
            {(this.state.purchases || []).map(row => (
                <TableRow key={row.id}>
                    <TableCell>{this.getGoldPackData(row.product_id, "name")}</TableCell>
                    <TableCell align="right">{Helpers.formatDateWithTime(row.created_at)}</TableCell>
                    <TableCell align="right">{row.purchase_status}</TableCell>
                    <TableCell align="right">{`€${this.getGoldPackData(row.product_id, "price")}`}</TableCell>
                </TableRow>
            ))}

            <TableRow key="summary">
                <TableCell colSpan={3} align="right">Total</TableCell>
                <TableCell align="right">{`€ ${this.totalPrice().toFixed(2)}`}</TableCell>
            </TableRow>
        </React.Fragment>
    }

    renderAddPurchaseModal() {
        const {addPurchaseModal} = this.state;

        if (!addPurchaseModal.visible) {
            return null;
        }

        return <Dialog
            open={addPurchaseModal.visible}
            onClose={this.onHideAddPurchaseModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Add Purchase
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item sm={12} spacing={2}>
                        <TextField
                            id="orderId"
                            label="Order ID"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={addPurchaseModal.orderId}
                            onChange={e => this.onChangeAddPurchase(e, "orderId")}
                            helperText="For iOS: Use Order ID or Purchase Token. For Android: Purchase Token is required."
                        />
                    </Grid>

                    <Grid item sm={12} spacing={2}>
                        <TextField
                            id="PurchaseToken"
                            label="Purchase Token"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={addPurchaseModal.purchaseToken}
                            onChange={e => this.onChangeAddPurchase(e, "purchaseToken")}
                            helperText="For iOS: Use Order ID or Purchase Token. For Android: Purchase Token is required."
                        />
                    </Grid>
                    

                    <Grid item sm={12} spacing={2}>
                        <Select
                            labelId="store"
                            id="store"
                            value={addPurchaseModal.store}
                            onChange={e => this.onChangeAddPurchase(e, "store")}
                            fullWidth
                            variant="outlined"
                        >
                            {stores.map(store => (
                                <MenuItem key={store.store} value={store.store}>{store.name}</MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item sm={12} spacing={2}>
                        <Select
                            labelId="productId"
                            id="productId"
                            value={addPurchaseModal.productId}
                            onChange={e => this.onChangeAddPurchase(e, "productId")}
                            fullWidth
                            variant="outlined"
                        >
                            {sapphirePackages.map(item => (
                                <MenuItem key={item.packageId} value={item.packageId}>{item.packageId}, {`${item.sapphires} Sapphires`}</MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item sm={12} spacing={2}>
                        <Button
                            disableElevation
                            variant="contained"
                            onClick={this.addPurchase}
                            color="primary"
                            fullWidth
                        >
                            Add Purchase
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    }

    render() {
        return (
            <React.Fragment>
                {this.drawButtons()}

                <Paper elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Product</TableCell>
                                <TableCell align="right">Date</TableCell>
                                <TableCell align="right">Status</TableCell>
                                <TableCell align="right">Price</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderRows()}
                        </TableBody>
                    </Table>
                </Paper>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.closeModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth="md"
                >
                    <DialogTitle id="alert-dialog-title">
                        Create a deal for user
                    </DialogTitle>
                    <DialogContent>
                        <div style={{marginBottom: 15}}>
                            <div style={{display: "inline-block", marginRight: 25}}>
                                <FormControlLabel
                                    control={<Checkbox onChange={this.onSelectAllProducts} checked={this.state.selectAllProducts} />}
                                    label="Select All"
                                    labelPlacement="start"
                                />
                            </div>
                        </div>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                    </TableCell>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Gold</TableCell>
                                    <TableCell>Platform</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Slot Index</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getProducts().map(product => (
                                    this.productItem(product)
                                ))}
                            </TableBody>
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.closeModal} color="primary">
                            Cancel
                        </Button>
                        <Button disableElevation onClick={this.createDeals} color="primary">
                            Create a deal
                        </Button>
                    </DialogActions>
                </Dialog>

                {this.renderAddPurchaseModal()}



            </React.Fragment>
        );
    }
}
